import {NgClass}                            from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';

@Component({
			   selector   : 'app-input-wrapper',
			   imports: [
				   NgClass
			   ],
			   templateUrl: './input-wrapper.component.html',
			   styleUrl   : './input-wrapper.component.css'
		   })
export class InputWrapperComponent {
	label = input<string>();
	descr = input<string>();
	units = input<string>();
	blend = input(true, {transform: booleanAttribute});
}
